export default function validation(response, messages, demandes) {
  if (!response.data || !response.data.error || !response.data.error.validationErrors) {
    return;
  }
  response.data.error.validationErrors.forEach((error) => {
    const message = error.message;
    if (message.indexOf('IN_OT') === 0) {
      messages.push({ message: 'editionIntervention.error.inOt' });
    }
    if (message.indexOf('COMPANY_SHOULD_CONTAINS_TECHNIC_WORK_ORDER_PRODUCT') === 0) {
      messages.push({
        message: 'detailIntervention.error.technicWorkOrdreProduct',
      });
    }
    if (message.indexOf('DEMANDE_LOGISTIQUE_NEED_TYPE_OT') === 0) {
      if (!demandes || !demandes.length) {
        messages.push({ message: 'detailIntervention.error.typeOt' });
      } else {
        const elements = message.split('|')[0].split('@');
        const demandeFind = demandes.find((d) => { return d.id === elements[1]; });
        if (demandeFind) {
          messages.push({
            message: 'listeIntervention.error.typeOt',
            parametres: {
              code: demandeFind.code,
            },
          });
        } else {
          messages.push({ message: 'detailIntervention.error.typeOt' });
        }
      }
    }
    if (message.indexOf('PATRIMOINE_CAN_NOT_MODIFY') === 0) {
      messages.push({
        message: 'editionIntervention.infoGenerale.canNotChangePatrionine',
      });
    }
  });
}
